module.exports = __webpack_public_path__ + "img/12.96f6ea5b.jpg";